import React, { useEffect } from 'react'
import { Switch, Route, useHistory } from 'react-router-dom'
import ROUTES from '../routers/routes'
import ProtectedRoute from '../components/ProtectedRoute/ProtectedRoute'
import Home from '../pages/Home/Home'
import Error404 from '../pages/Error404/Error404'
import { useAuthentication } from '../context/authenticationContext'
import { Construction } from '../pages/Construction/Construction'
import CreateForm from '../pages/Formularios/PreElegibilidad/Crear'
import createMiPymeForm from '../pages/Formularios/MiPyme'
import ViewForms from '../pages/Formularios/PreElegibilidad/Consulta/Enviados'
import DetailForms from '../pages/Formularios/PreElegibilidad/Detalles'
import ElegibilityDetail from '../pages/Formularios/Elegibilidad/Detalle'

// import DraftForms from '../pages/Formularios/PreElegibilidad/Consulta/Borrador'
import CreateEditForm from '../pages/Formularios/PreElegibilidad/Editar/'
import pdfGenerator from '../pages/Formularios/PreElegibilidad/Crear/PDFConstructor'
import ElegibilidadForm from '../pages/Formularios/Elegibilidad/principal'
import FormsDraftWrapperElegibilidad from '../pages/Formularios/Elegibilidad/Mantenimientos/Borrador/index'
import ElegibilidadFormEdit from '../pages/Formularios/Elegibilidad/Mantenimientos/Edit/editElegibilidad'

import IFICreateForm from '../pages/IFIS/PreElegibilidad/Crear'
import IFIcreateMiPymeForm from '../pages/IFIS/MiPyme'
import IFIViewForms from '../pages/IFIS/PreElegibilidad/Consulta/Enviados'
import IFIDetailForms from '../pages/IFIS/PreElegibilidad/Detalles'
import IFIDraftForms from '../pages/IFIS/PreElegibilidad/Consulta/Borrador'
import IFICreateEditForm from '../pages/IFIS/PreElegibilidad/Editar/index'
import IFIpdfGenerator from '../pages/IFIS/PreElegibilidad/Crear/PDFConstructor'
import IFIElegibilidadForm from '../pages/IFIS/Elegibilidad/principal'
import IFIFormsDraftWrapperElegibilidad from '../pages/IFIS/Elegibilidad/Mantenimientos/Borrador/index'
import IFIElegibilidadFormEdit from '../pages/IFIS/Elegibilidad/Mantenimientos/Edit/editElegibilidad'
import IFIFormsSent from '../pages/IFIS/Elegibilidad/Mantenimientos/Enviados/index'
import MIPYMEFormsSent from '../pages/Formularios/Elegibilidad/Mantenimientos/Enviados/index'
import MIPYMESOLICITUD from '../pages/Formularios/Representacion/SolicitarRepresentacion/index'
import NotificacionIFIMIPYME from '../pages/Formularios/Representacion/RepresentarMipyme/index'
import EliminarRepresentacionMIPYME from '../pages/Formularios/Representacion/EliminarPresentacionMIPYME/index'
import EliminarRepresentacionIFI from '../pages/Formularios/Representacion/EliminarPresentacionIFI/index'
import SolicitudWorkshopIfi from '../pages/Formularios/Representacion/SolicitudWorkshop/index'
import { QuestionsWorkshop } from '../pages/Formularios/Workshop/QuestionsWorkshop/QuestionsWorkshop'
import FormAsistencia from '../pages/IFIS/AsistenciaTecnica/principal'
import FormAsistenciaTecnicaView from '../pages/IFIS/AsistenciaTecnica/Detalle'
import FormMonitoreoYEvaluacion from '../pages/IFIS/MonitoreoYEvaluacion/principal'
import Questionnaires from '../pages/IFIS/CuestionarioMonitoreoEvaluacion/Principal'
import ViewCuestionary from '../pages/IFIS/CuestionarioMonitoreoEvaluacion/ViewCuestionary'
import FormMonitoreoEvaluacionView from '../pages/IFIS/MonitoreoYEvaluacion/Detalle'
import FormRepresentationIFI from '../pages/Formularios/Representacion/MIPYMERepresentadas'
import FormActivationMIPYME from '../pages/IFIS/ActivationMIPYME'

function usePageViews() {
  const history = useHistory()
  const { isAuthenticated, UserRoles } = useAuthentication()
  useEffect(() => {
    if (isAuthenticated) {
      const namepath = window.sessionStorage.getItem('sessionpathname')
      history.push(namepath)
    }
  }, [UserRoles])
}
export const AppRouter = () => {
  const { isAuthenticated, UserRoles } = useAuthentication()
  usePageViews()
  return (
    <Switch>
      <ProtectedRoute
        isAuthenticated={isAuthenticated}
        path={ROUTES.CONSTRUCTION.pathname}
        UserRoles={UserRoles}
        component={Construction}
        exact
      />

      <Route
        isAuthenticated={isAuthenticated}
        path={ROUTES.HOME.pathname}
        component={Home}
        exact
      />
      <Route
        isAuthenticated={isAuthenticated}
        path={ROUTES.ERROR404.pathname}
        component={Error404}
        exact
      />

      <Route
        isAuthenticated={isAuthenticated}
        path={ROUTES.REGISTRAR.pathname}
        roles={ROUTES.REGISTRAR.roles}
        userRoles={UserRoles}
        component={CreateForm}
        exact
      />

      {/** AQUI ESTAN LAS PANTALLAS DE ELEGIBILIDAD */}
      <ProtectedRoute
        isAuthenticated={isAuthenticated}
        path={ROUTES.REGISTRAR_ELEGIBILIDAD.pathname}
        roles={ROUTES.REGISTRAR_ELEGIBILIDAD.roles}
        userRoles={UserRoles}
        component={ElegibilidadForm}
        exact
      />

      <ProtectedRoute
        isAuthenticated={isAuthenticated}
        path={ROUTES.BORRADORELEGIBILIDAD.pathname}
        roles={ROUTES.BORRADORELEGIBILIDAD.roles}
        userRoles={UserRoles}
        component={FormsDraftWrapperElegibilidad}
        exact
      />

      <ProtectedRoute
        isAuthenticated={isAuthenticated}
        path={ROUTES.EDITARELEGIBILIDAD.pathname}
        roles={ROUTES.EDITARELEGIBILIDAD.roles}
        userRoles={UserRoles}
        component={ElegibilidadFormEdit}
        exact
      />
      {/** FIN PANTALLAS DE ELEGIBILIDAD */}
      <ProtectedRoute
        isAuthenticated={isAuthenticated}
        path={ROUTES.VISTA.pathname}
        // roles={ROUTES.DESEMBOLSOS.roles}
        // userRoles={UserRoles}
        component={ViewForms}
        exact
      />

      <ProtectedRoute
        isAuthenticated={isAuthenticated}
        path={ROUTES.DETALLES.pathname}
        roles={ROUTES.DETALLES.roles}
        userRoles={UserRoles}
        component={DetailForms}
        exact
      />

      <ProtectedRoute
        isAuthenticated={isAuthenticated}
        path={ROUTES.DETALLESELEGIBILIDAD.pathname}
        roles={ROUTES.DETALLESELEGIBILIDAD.roles}
        userRoles={UserRoles}
        component={ElegibilityDetail}
        exact
      />

      <ProtectedRoute
        isAuthenticated={isAuthenticated}
        path={ROUTES.EDITAR.pathname}
        roles={ROUTES.EDITAR.roles}
        userRoles={UserRoles}
        component={CreateEditForm}
        exact
      />

      <ProtectedRoute
        isAuthenticated={isAuthenticated}
        path={ROUTES.PDF.pathname}
        // roles={ROUTES.DESEMBOLSOS.roles}
        // userRoles={UserRoles}
        component={pdfGenerator}
        exact
      />

      <ProtectedRoute
        isAuthenticated={isAuthenticated}
        path={ROUTES.MIPYME.pathname}
        roles={ROUTES.MIPYME.roles}
        userRoles={UserRoles}
        component={createMiPymeForm}
        exact
      />

      {/* INICIO PANTALLAS IFIS */}

      <ProtectedRoute
        isAuthenticated={isAuthenticated}
        path={ROUTES.IFIREGISTRAR.pathname}
        roles={ROUTES.IFIREGISTRAR.roles}
        userRoles={UserRoles}
        component={IFICreateForm}
        exact
      />

      {/** AQUI ESTAN LAS PANTALLAS DE ELEGIBILIDAD */}
      <ProtectedRoute
        isAuthenticated={isAuthenticated}
        path={ROUTES.IFIREGISTRAR_ELEGIBILIDAD.pathname}
        roles={ROUTES.IFIREGISTRAR_ELEGIBILIDAD.roles}
        userRoles={UserRoles}
        component={IFIElegibilidadForm}
        exact
      />

      <ProtectedRoute
        isAuthenticated={isAuthenticated}
        path={ROUTES.IFIBORRADORELEGIBILIDAD.pathname}
        roles={ROUTES.IFIBORRADORELEGIBILIDAD.roles}
        userRoles={UserRoles}
        component={IFIFormsDraftWrapperElegibilidad}
        exact
      />

      <ProtectedRoute
        isAuthenticated={isAuthenticated}
        path={ROUTES.IFIEDITARELEGIBILIDAD.pathname}
        roles={ROUTES.IFIEDITARELEGIBILIDAD.roles}
        userRoles={UserRoles}
        component={IFIElegibilidadFormEdit}
        exact
      />
      {/** FIN PANTALLAS DE ELEGIBILIDAD */}
      {/** INICIO WORKSHOP */}
      <ProtectedRoute
        isAuthenticated={isAuthenticated}
        path={ROUTES.WORKSHOP.pathname}
        roles={ROUTES.WORKSHOP.roles}
        userRoles={UserRoles}
        component={QuestionsWorkshop}
        exact
      />
      {/** FIN WORKSHOP */}
      <ProtectedRoute
        isAuthenticated={isAuthenticated}
        path={ROUTES.IFIVISTA.pathname}
        roles={ROUTES.IFIVISTA.roles}
        userRoles={UserRoles}
        component={IFIViewForms}
        exact
      />

      <ProtectedRoute
        isAuthenticated={isAuthenticated}
        path={ROUTES.IFIDETALLES.pathname}
        roles={ROUTES.IFIDETALLES.roles}
        userRoles={UserRoles}
        component={IFIDetailForms}
        exact
      />

      <ProtectedRoute
        isAuthenticated={isAuthenticated}
        path={ROUTES.IFIBORRADOR.pathname}
        roles={ROUTES.IFIBORRADOR.roles}
        userRoles={UserRoles}
        component={IFIDraftForms}
        exact
      />

      <ProtectedRoute
        isAuthenticated={isAuthenticated}
        path={ROUTES.IFIEDITAR.pathname}
        roles={ROUTES.IFIEDITAR.roles}
        userRoles={UserRoles}
        component={IFICreateEditForm}
        exact
      />

      <ProtectedRoute
        isAuthenticated={isAuthenticated}
        path={ROUTES.IFIPDF.pathname}
        // roles={ROUTES.DESEMBOLSOS.roles}
        // userRoles={UserRoles}
        component={IFIpdfGenerator}
        exact
      />

      <ProtectedRoute
        isAuthenticated={isAuthenticated}
        path={ROUTES.IFIMIPYME.pathname}
        roles={ROUTES.IFIMIPYME.roles}
        userRoles={UserRoles}
        component={IFIcreateMiPymeForm}
        exact
      />
      <ProtectedRoute
        isAuthenticated={isAuthenticated}
        path={ROUTES.IFIFORMSSENT.pathname}
        roles={ROUTES.IFIFORMSSENT.roles}
        userRoles={UserRoles}
        component={IFIFormsSent}
        exact
      />
      <ProtectedRoute
        isAuthenticated={isAuthenticated}
        path={ROUTES.MIPYMEFORMSENT.pathname}
        roles={ROUTES.MIPYMEFORMSENT.roles}
        userRoles={UserRoles}
        component={MIPYMEFormsSent}
        exact
      />
      {/* MODULA DE REPRESENTAR */}
      <ProtectedRoute
        isAuthenticated={isAuthenticated}
        path={ROUTES.REPRESENTARMIPYME.pathname}
        roles={ROUTES.REPRESENTARMIPYME.roles}
        userRoles={UserRoles}
        component={MIPYMESOLICITUD}
        exact
      />
      <ProtectedRoute
        isAuthenticated={isAuthenticated}
        path={ROUTES.NOTIFICACIONIFIMIPYME.pathname}
        roles={ROUTES.NOTIFICACIONIFIMIPYME.roles}
        userRoles={UserRoles}
        component={NotificacionIFIMIPYME}
        exact
      />
      <ProtectedRoute
        isAuthenticated={isAuthenticated}
        path={ROUTES.ELIMINARMIPYMESIFIS.pathname}
        roles={ROUTES.ELIMINARMIPYMESIFIS.roles}
        userRoles={UserRoles}
        component={EliminarRepresentacionMIPYME}
        exact
      />
      <ProtectedRoute
        isAuthenticated={isAuthenticated}
        path={ROUTES.ELIMINARIFIMIPYMES.pathname}
        roles={ROUTES.ELIMINARIFIMIPYMES.roles}
        userRoles={UserRoles}
        component={EliminarRepresentacionIFI}
        exact
      />
      <ProtectedRoute
        isAuthenticated={isAuthenticated}
        path={ROUTES.SOLICITUDWORKSHOP.pathname}
        roles={ROUTES.SOLICITUDWORKSHOP.roles}
        userRoles={UserRoles}
        component={SolicitudWorkshopIfi}
        exact
      />

      {/* Pantallas Asistencia tecnica */}
      <ProtectedRoute
        isAuthenticated={isAuthenticated}
        path={ROUTES.ASISTENCIATECNICA.pathname}
        roles={ROUTES.ASISTENCIATECNICA.roles}
        userRoles={UserRoles}
        component={FormAsistencia}
        exact
      />

      <ProtectedRoute
        isAuthenticated={isAuthenticated}
        path={ROUTES.ASISTENCIATECNICAEDITAR.pathname}
        roles={ROUTES.ASISTENCIATECNICAEDITAR.roles}
        userRoles={UserRoles}
        component={FormAsistencia}
        exact
      />

      <ProtectedRoute
        isAuthenticated={isAuthenticated}
        path={ROUTES.ASISTENCIATECNICAENVIADOS.pathname}
        roles={ROUTES.ASISTENCIATECNICAENVIADOS.roles}
        userRoles={UserRoles}
        component={FormAsistenciaTecnicaView}
        exact
      />

      {/* Pantallas Monitoreo y Evaluacion */}
      <ProtectedRoute
        isAuthenticated={isAuthenticated}
        path={ROUTES.MONITOREOYEVALUACION.pathname}
        roles={ROUTES.MONITOREOYEVALUACION.roles}
        userRoles={UserRoles}
        component={FormMonitoreoYEvaluacion}
        exact
      />

      <ProtectedRoute
        isAuthenticated={isAuthenticated}
        path={ROUTES.CUESTIONARIOMONITOREOYEVALUACIONLISTADO.pathname}
        roles={ROUTES.CUESTIONARIOMONITOREOYEVALUACIONLISTADO.roles}
        userRoles={UserRoles}
        component={Questionnaires}
        exact
      />

      <ProtectedRoute
        isAuthenticated={isAuthenticated}
        path={ROUTES.CUESTIONARIOMONITOREOYEVALUACION.pathname}
        roles={ROUTES.CUESTIONARIOMONITOREOYEVALUACION.roles}
        userRoles={UserRoles}
        component={ViewCuestionary}
        exact
      />

      <ProtectedRoute
        isAuthenticated={isAuthenticated}
        path={ROUTES.MONITOREOYEVALUACIONENVIADOS.pathname}
        roles={ROUTES.MONITOREOYEVALUACIONENVIADOS.roles}
        userRoles={UserRoles}
        component={FormMonitoreoEvaluacionView}
        exact
      />

      <ProtectedRoute
        isAuthenticated={isAuthenticated}
        path={ROUTES.REPRESENTACIONMIPYME.pathname}
        roles={ROUTES.REPRESENTACIONMIPYME.roles}
        userRoles={UserRoles}
        component={FormRepresentationIFI}
        exact
      />

      <ProtectedRoute
        isAuthenticated={isAuthenticated}
        path={ROUTES.ACTIVATIONMIPYME.pathname}
        roles={ROUTES.ACTIVATIONMIPYME.roles}
        userRoles={UserRoles}
        component={FormActivationMIPYME}
        exact
      />
      {/* FIN PANTALLAS IFIS */}

      {/* TODO: Add 401 page / flow */}
    </Switch>
  )
}
